import axios from '@api';

import { type NotificationResponse } from './types';
import { transformNotificationsResponse } from './utilities/helpers';

export const readAllNotifications = () => {
  return axios<{ message: string }>({
    method: 'get',
    url: '/api/notification/read_all',
    withCredentials: true,
  });
};

export const readNotifications = ({ page }: { page: number | string }) => {
  return axios<NotificationResponse>({
    method: 'get',
    transformResponse: [(data: string) => transformNotificationsResponse(JSON.parse(data))],
    url: `/api/notification?page=${page}`,
    withCredentials: true,
  });
};
